import type { PresenceUser } from '../../features/presence/PresenceStack';
import type { SliceCreator } from '../state';

/**
 * Who else is connected, one entry per SOCKET.
 *
 * NOT PER PERSON, and that is the whole subtlety. Somebody with two tabs open appears twice,
 * and collapsing that is the consumer's job because which of their tabs to show depends on
 * what is being shown: the top bar wants the most engaged one, a node badge wants whichever
 * socket is on that node. `PresenceStack` already does that reduction; storing a
 * pre-collapsed roster here would take the choice away from it.
 *
 * Its own slice because the roster changes on a schedule nothing else shares — somebody
 * opening a tab three rooms away — and nothing that renders the map should re-render for it.
 */
export interface PresenceSlice {
  presenceRoster: readonly PresenceUser[];
  setPresenceRoster: (roster: readonly PresenceUser[]) => void;
}

export const createPresenceSlice: SliceCreator<PresenceSlice> = (set, get) => ({
  presenceRoster: [],
  // Compared entry by entry, because the mirror hands over a fresh array on every sync while
  // the entries themselves are the socket's own objects and change only when a message
  // arrives. Without this every map node re-evaluates its selector on every render.
  setPresenceRoster: (roster) => {
    const prev = get().presenceRoster;
    if (prev.length === roster.length && prev.every((u, i) => u === roster[i])) return;
    set({ presenceRoster: roster });
  },
});
